<svelte:options runes={true} />

<script lang="ts">
  import { reactTo } from '@utils';
  import type { KeyManager } from '@reactive';

  let {
    keyManager
  }: {
    keyManager: KeyManager;
  } = $props();

  let element: HTMLElement;

  let displayedContent: string = $state('');
  // let lastHudContent: string | undefined;
  let visibleTimeout: number | undefined;
  let visible = false;

  $effect(() => {
    reactTo(keyManager.hudContentChange);
    // console.log('hudMessage', keyManager.hudMessage);

    if (keyManager.hudContent !== undefined) {
      show(keyManager.hudContent);
    } else {
      hide();
    }
  });

  function show(message: string) {
    // console.log('Setting HUD message to', message);
    displayedContent = message;

    // console.log('Resetting HUD timer');
    if (visibleTimeout) {
      clearTimeout(visibleTimeout);
    }
    visibleTimeout = setTimeout(() => {
      hide();
    }, keyManager.hudTimeout) as unknown as number;

    if (visible) {
      return;
    }
    visible = true;
    // console.log('Showing HUD');

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    element.offsetHeight; // Trigger reflow to reset animation
    element.style.animation = 'hudFadeIn 0.2s ease-in-out forwards';
  }

  function hide() {
    if (!visible) {
      return;
    }
    // console.log('Hiding HUD');
    visible = false;
    if (visibleTimeout) {
      clearTimeout(visibleTimeout);
      visibleTimeout = undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    element.offsetHeight; // Trigger reflow to reset animation
    element.style.animation = 'hudFadeOut 0.4s ease-in-out forwards';
  }
</script>

<style>
  :global {
    @keyframes hudFadeIn {
      0% {
        opacity: 0;
        transform: translate(-50%, 0) scale(0.9);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, 0) scale(1);
      }
    }

    @keyframes hudFadeOut {
      0% {
        opacity: 1;
        transform: translate(-50%, 0) scale(1);
      }
      100% {
        opacity: 0;
        transform: translate(-50%, 0) scale(0.9);
      }
    }
  }

  .hud {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
    padding: 1.5rem;
    border-radius: 1rem;
    max-width: 80%;
    border: 2px solid var(--sl-color-neutral-500);
    user-select: none;
    text-align: center;
    pointer-events: none;
    opacity: 0;
  }

  .hud::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--sl-color-neutral-0);
    opacity: 0.8;
    border-radius: 1rem;
    z-index: -1;
  }
</style>

<div bind:this={element} class="hud">
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html displayedContent}
</div>
